import { Tooltip } from '@material-ui/core';
import React from 'react';

import { Container, Dot } from './styles';

interface INotificationProps {
  onSelectNotification: () => void;
  device_name: string;
  sensor_name?: string;
  read?: boolean;
  type: 'sensor' | 'battery';
}

const Notification: React.FC<INotificationProps> = ({ onSelectNotification, device_name, sensor_name, read, type }) => {
  return (
    <Tooltip title={!read ? 'Clique para ver a notificação' : ''}>
      <Container onClick={onSelectNotification}>
        <strong>Alerta {`${type === 'battery' ? 'de bateria' : 'de sensor'}: `}</strong>
        <span>{`Dispositivo ${device_name}`}</span>
        {sensor_name && <span>{` - ${sensor_name}`}</span>}
        {!read && <Dot />}
      </Container>
    </Tooltip>
  );
};

export default Notification;
